import React, { useState, useEffect } from "react";
import "./EpisodeList.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import closeIcon from "../../../common/assets/images/x-close.png";
import { Grid, Typography, TextField } from '@mui/material';
import {
  Container,
  Modal,
  Row,
  Col,
  Dropdown,
  DropdownButton,
  Form,
  Button,
  Badge,
} from "react-bootstrap";
import { formatCalenderDate } from "./Util";
import Select from "react-select";
import {
  getFilterEpisodeLists,
  setEpisodeListFilterObj,
} from "./redux/EpisodeListSlicer";
import { useDispatch, useSelector } from "react-redux";

const EpisodeListFilter = ({
  showepisodeListFilter,
  closeEpisodeFilterModal,
}) => {
  const dispatch = useDispatch();
  const { episodeListFilterObj } = useSelector((state) => state.episodeList);
  const { sort_by, sort_order, page_size, episode_identifier, page, ...newepisodeListFilterObj } =
    episodeListFilterObj;

  const { filterOptions } = useSelector(
    (state) => state.episodeList?.getFilterOptions
  );
  const dateFormat = "yyyy-MM-dd";

  const EpisodeListFilterSubmit = (e) => {
    // const payload = {
    //   ...episodeListFilterObj,
    //   admission_date: formatCalenderDate(episodeListFilterObj.admission_date),
    //   separation_date: formatCalenderDate(episodeListFilterObj.separation_date),
    // };

    // const trimmedData = Object.keys(episodeListFilterObj).reduce((acc, key) => {
    //   const value = payload[key];
    //   acc[key] = typeof value === 'string' ? value.trim() : value;
    //   return acc;
    // }, {});

    e.preventDefault();
    dispatch(getFilterEpisodeLists(episodeListFilterObj));
    closeEpisodeFilterModal();
  };

  const handleEpisodeListFilterChange = (name, value) => {
    dispatch(
      setEpisodeListFilterObj({
        ...episodeListFilterObj,
        page: 1,
        [name]: value,
      })
    );
  };

  const handleCheckboxChange = (name, item) => {
    // const updatedList = episodeListFilterObj[name]?.includes(item)
    //   ? episodeListFilterObj[name].filter((value) => value !== item)
    //   : [...episodeListFilterObj[name], item];

    dispatch(
      setEpisodeListFilterObj({
        ...episodeListFilterObj,
        page: 1,
        [name]: item,
      })
    );
  };

  const handleReset = () => {
    const resetState = {
      // medical_record_number: "",
      medical_record_number: "",
      // episode_identifier: "",
      admission_date: "",
      separation_date: "",
      length_of_stay: "",
      speciality: [],
      status: [],
      drg: [],
      document_name: [],
      page_size: 20,
      page: 1,
      // priority: "",
      // Provisional_NWAU: "",
    };

    dispatch(setEpisodeListFilterObj(resetState));
    // dispatch(getFilterEpisodeLists(resetState));
  };

  const handleFilterRemove = (filterName, item) => {
    const updatedFilterObj = { ...episodeListFilterObj };
    if (Array.isArray(updatedFilterObj[filterName])) {
      // If the filter is an array, filter out the specific item
      updatedFilterObj[filterName] = updatedFilterObj[filterName].filter(
        (value) => value !== item
      );
    } else {
      // If it's not an array, reset the value to the default value ("" or null)
      updatedFilterObj[filterName] = filterName === "date" ? null : "";
    }
    // Update the state with the modified filter object
    dispatch(setEpisodeListFilterObj(updatedFilterObj));
  };
  const hasValue = Object.values(newepisodeListFilterObj).some(
    (item) =>
      item !== "" &&
      item !== null &&
      (Array.isArray(item) ? item.length > 0 : true)
  );


  const getSelectedOptions = (filterName) => {
    const options = filterOptions?.[filterName]?.map((item) => ({
      value: item,
      label: item,
    }));

    const selectedValues = episodeListFilterObj?.[filterName] || [];
    return options?.filter((option) => selectedValues.includes(option.value));
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      maxHeight: '60px',
      overflowY: "auto"
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: '0',
      // display: "none"
      
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: '0',
      display: "none"
    }),
    multiValue: (provided) => ({
      ...provided,
      maxWidth: '100%',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }),
  };

  return (
    <div className="episode-list-filter-container">
      <Modal
        show={showepisodeListFilter}
        onHide={closeEpisodeFilterModal}
        backdrop="static"
        className="episode-list-filter-modal"
        // size="lg"
        dialogClassName="modal-xl"
        keyboard={false}
      >
        <Modal.Header closeButton className="episode-list-modal-header">
          <Modal.Title className="episode-list-filter-modal-title">
            Episode Filters
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {newepisodeListFilterObj &&
            Object.values(newepisodeListFilterObj).length > 0 && (
              <div className="episodelist-filter-breadcrumb-section">
                <div className="episodelist-breadcrumb-list">
                  {Object.keys(newepisodeListFilterObj).map((key) => {
                    const value = newepisodeListFilterObj[key];
                    // Check for admission_date or separation_date and format the date
                    if (key === "admission_date" || key === "separation_date") {
                      return (
                        value && (
                          <Badge
                            key={key}
                            bg="light"
                            text="dark"
                            className="episodeListFilterObj-breadcrumbItem"
                          >
                            <span>
                              {key === "admission_date"
                                ? "Admission Date"
                                : "Separation Date"}
                              : {new Date(value).toLocaleDateString()}
                            </span>
                            <img
                              src={closeIcon}
                              height="15px"
                              width="15px"
                              onClick={() => handleFilterRemove(key)}
                              className="episodeListFilterObj-close-icon"
                              alt={`Remove filter: ${key}`}
                            />
                          </Badge>
                        )
                      );
                    }
                    if (
                      key === "speciality" ||
                      key === "status" ||
                      key === "drg" ||
                      key === "document_name"
                    ) {
                      return (
                        <div className="episodelist-breadcrumb-list">
                          {Array.isArray(value) ? (
                            value.map((item, index) => (
                              <Badge
                                key={`${key}-${index}`}
                                bg="light"
                                text="dark"
                                className="episodeListFilterObj-breadcrumbItem"
                              >
                                <span>
                                  {key.charAt(0).toUpperCase() + key.slice(1)}:
                                  {item.replace(".txt", "")}
                                </span>
                                <span>
                                  <img
                                    src={closeIcon}
                                    height="15px"
                                    width="15px"
                                    onClick={() =>
                                      handleFilterRemove(key, item)
                                    }
                                    className="episodeListFilterObj-close-icon"
                                    alt={`Remove filter: ${key}`}
                                  />
                                </span>
                              </Badge>
                            ))
                          ) : (
                            <Badge
                              key={key}
                              bg="light"
                              text="dark"
                              className="episodeListFilterObj-breadcrumbItem"
                            >
                              <span>
                                {key.charAt(0).toUpperCase() + key.slice(1)}:
                                {value.includes("-")
                                  ? value.slice(0, value.indexOf("-"))
                                  : value}
                              </span>
                              <span>
                                <img
                                  src={closeIcon}
                                  height="15px"
                                  width="15px"
                                  onClick={() => handleFilterRemove(key, value)}
                                  className="episodeListFilterObj-close-icon"
                                  alt={`Remove filter: ${key}`}
                                />
                              </span>
                            </Badge>
                          )}
                        </div>
                      );
                    }
                    if (
                      typeof value === "string" || typeof value === "number") {
                      return (
                        value && (
                          <Badge
                            key={key}
                            bg="light"
                            text="dark"
                            className="episodeListFilterObj-breadcrumbItem"
                          >
                            <span>
                              {key === "medical_record_number"
                                ? "Patient Identifier"
                                // : key === "episode_identifier"
                                // ? "Episode Identifier"
                                : key === "length_of_stay"
                                ? "Length Of Stay"
                                : key.charAt(0).toUpperCase() + key.slice(1)}
                              : {value}
                            </span>
                            <img
                              src={closeIcon}
                              height="15px"
                              width="15px"
                              onClick={() => handleFilterRemove(key)}
                              className="episodeListFilterObj-close-icon"
                              alt={`Remove filter: ${key}`}
                            />
                          </Badge>
                        )
                      );
                    }
                    return null;
                  })}
                </div>
                {hasValue && (
                  <div>
                    <Button
                      onClick={handleReset}
                      className="episodelist-reset-btn"
                    >
                      Clear All
                    </Button>
                  </div>
                )}
              </div>
            )}

          <form 
          // onSubmit={EpisodeListFilterSubmit}
          >
            <Container>
              <Row>
                <Col className="p-0 mb-4 el-filter-input">
                  <label
                    htmlFor="medical_record_number"
                    className="episodelist-filter-label"
                  >
                    {/* medical_record_number */}
                    Patient Identifier
                  </label>
                  <input
                    className="episodelist-filter-input-text"
                    type="text"
                    autoComplete="off"
                    id="medical_record_number"
                    name="medical_record_number"
                    placeholder="Patient Identifier"
                    value={episodeListFilterObj.medical_record_number}
                    onChange={(e) =>
                      handleEpisodeListFilterChange(
                        "medical_record_number",
                        e.target.value
                      )
                    }
                  />
                </Col>
                </Row>
                {/* <Row>
                <Col className="p-0 mb-4">
                  <label
                    htmlFor="episode_identifier"
                    className="episodelist-filter-label"
                  >
                    Episode Identifier
                  </label>
                  <input
                    className="episodelist-filter-input-text"
                    type="text"
                    autoComplete="off"
                    id="episode_identifier"
                    name="episode_identifier"
                    placeholder="Episode Identifier"
                    value={episodeListFilterObj.episode_identifier}
                    onChange={(e) =>
                      handleEpisodeListFilterChange(
                        "episode_identifier",
                        e.target.value
                      )
                    }
                  />
                </Col>
              </Row> */}
              </Container>
              <Grid container spacing={1} size={{xs:12,sm:12,md:12}}>
    {/* Admission Date */}
      <Grid item size={{xs:12,sm:12,md:4}}>
        <label htmlFor="admission_date" className="episodelist-filter-label">
          Admission Date
        </label>
        <DatePicker
          selected={episodeListFilterObj.admission_date || ""}
          onChange={(date) =>
            handleEpisodeListFilterChange(
              "admission_date",
              formatCalenderDate(date)
            )
          }
          dateFormat={dateFormat}
          showYearDropdown
          yearDropdownItemNumber={150}
          scrollableYearDropdown
          placeholderText="YYYY/MM/DD"
          className="episode-filter-date-picker"
        />
      </Grid>

      {/* Discharge Date */}
      <Grid item size={{xs:12,sm:12,md:4}}>
        <label htmlFor="separation_date" className="episodelist-filter-label">
          Discharge Date
        </label>
        <DatePicker
          selected={episodeListFilterObj.separation_date || ""}
          onChange={(date) =>
            handleEpisodeListFilterChange(
              "separation_date",
              formatCalenderDate(date)
            )
          }
          dateFormat={dateFormat}
          showYearDropdown
          yearDropdownItemNumber={150}
          scrollableYearDropdown
          placeholderText="YYYY/MM/DD"
          className="episode-filter-date-picker"
        />
      </Grid>

      {/* LOS */}
      <Grid item size={{xs:12,sm:12,md:4}}>
        <label htmlFor="length_of_stay" className="episodelist-filter-label">
          LOS
        </label>
        <input
          className="episodelist-filter-input-text"
          type="number"
          min="0"
          autoComplete="off"
          id="length_of_stay"
          name="length_of_stay"
          placeholder="Length Of Stay"
          value={episodeListFilterObj.length_of_stay}
          onChange={(e) =>
            handleEpisodeListFilterChange(
              "length_of_stay",
              e.target.value ? Number(e.target.value) : null
            )
          }
        />
      </Grid>

      {/* Specialty Type */}
      <Grid item size={{xs:12,sm:12,md:4}}>
        <label htmlFor="speciality" className="episodelist-filter-label">
          Specialty Type
        </label>
        <Select 
          isMulti
          name="speciality"
          options={filterOptions?.speciality?.map((item) => ({
            value: item,
            label: item
          }))}
          value={getSelectedOptions("speciality")}
          styles={customStyles}
          maxMenuHeight={100}
          className="episodelist-filter-select"
          placeholder="Specialty Type"
          onChange={(selectedOption) => {
            const selectedValues = selectedOption.map(
              (option) => option.value
            );
            handleCheckboxChange("speciality", selectedValues);
          }}
        />
      </Grid>

      {/* Status */}
      <Grid item size={{xs:12,sm:12,md:4}}>
        <label htmlFor="status" className="episodelist-filter-label">
          Status
        </label>
        <Select
          isMulti
          name="status"
          options={filterOptions?.status?.map((item) => ({
            value: item,
            label: item
          }))}
          value={getSelectedOptions("status")}
          styles={customStyles}
          maxMenuHeight={250}
          className="episodelist-filter-select"
          placeholder="Status"
          onChange={(selectedOption) => {
            const selectedValues = selectedOption.map(
              (option) => option.value
            );
            handleCheckboxChange("status", selectedValues);
          }}
        />
      </Grid>

      {/* DRG */}
      <Grid item size={{xs:12,sm:12,md:4}}>
        <label htmlFor="drg" className="episodelist-filter-label">
          DRG
        </label>
        <Select
          isMulti
          name="drg"
          options={filterOptions?.drg?.map((item) => ({
            value: item,
            label: item
          }))}
          value={getSelectedOptions("drg")}
          styles={customStyles}
          maxMenuHeight={250}
          className="episodelist-filter-select"
          placeholder="DRG"
          onChange={(selectedOption) => {
            const selectedValues = selectedOption.map(
              (option) => option.value
            );
            handleCheckboxChange("drg", selectedValues);
          }}
        />
      </Grid>

      {/* Document Types */}
      <Grid item size={{xs:12,sm:12,md:4}}>
        <label htmlFor="document_name" className="episodelist-filter-label">
          Document Types
        </label>
        <Select
          isMulti
          name="document_name"
          options={filterOptions?.document_name?.map((item) => ({
            value: item,
            label: item
          }))}
          value={getSelectedOptions("document_name")}
          styles={customStyles}
          maxMenuHeight={250}
          className="episodelist-filter-select"
          placeholder="Document Types"
          onChange={(selectedOption) => {
            const selectedValues = selectedOption.map(
              (option) => option.value
            );
            handleCheckboxChange("document_name", selectedValues);
          }}
        />
      </Grid>
    </Grid>
            
          </form>
        </Modal.Body>
        <Modal.Footer className="episode-list-filter-modal-footer">
              <Button
                variant="secondary"
                type="button"
                className="el-filter-cancel"
                onClick={() => {
                  closeEpisodeFilterModal();
                }}
              >
                Cancel
              </Button>
              <Button variant="primary" className="el-filter-submit" type="submit" onClick={EpisodeListFilterSubmit}>
                Apply
              </Button>
            </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EpisodeListFilter;
